// extracted by mini-css-extract-plugin
module.exports = {"CancelAppointment":"CancelAppointment_CancelAppointment__2NL9Q","vtpImage":"CancelAppointment_vtpImage__15VB2"};